import React, { FC } from "react";
import Input from "./InputField";

interface InputWithLabelProps {
  label: string;
  name: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  type?: string;
  required?: boolean;
  placeholder?: string;
  step?: string | number;
  id?: string;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  hint?: string;
}

const InputWithLabel: FC<InputWithLabelProps> = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  required = false,
  placeholder,
  step,
  id,
  className = "",
  disabled = false,
  error = false,
  hint,
}) => {
  return (
    <div className="space-y-2">
      <label htmlFor={id || name} className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <Input
        type={type}
        id={id || name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={className}
        disabled={disabled}
        error={error}
        hint={hint}
        step={step}
      />
    </div>
  );
};

export default InputWithLabel; 